import React from "react";
import Footer from "../components/footer";
import SEOHead from "../components/SEOHead";

const ContactPage = () => {
  return (
    <div className="App">
      <SEOHead
        title="Contact Us"
        description="Get in touch with the BetterSleep team with questions, corrections or feedback."
        path="/contact"
      />
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "64px 24px" }}>
        <h1>Contact us</h1>
        <p>
          Questions, corrections or feedback on anything you've read on BetterSleep?
          Email us at{" "}
          <a href="mailto:info@bettersleep.ing">info@bettersleep.ing</a> and we'll
          get back to you.
        </p>
        <p>
          Spotted something inaccurate or out of date in an article? See our{" "}
          <a href="/categories">categories</a> to browse more, or email the address
          above and we'll review and update it.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
